import { useState } from 'react';
import { Download, X } from 'lucide-react';
import { useInstallPWA } from './useInstallPWA';

const PWA_BANNER_DISMISSED_KEY = 'pwa_banner_dismissed';

export default function PWAInstallBanner() {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(PWA_BANNER_DISMISSED_KEY) === 'true'
  );
  const { canShow, isIOS, install } = useInstallPWA();

  const dismiss = () => {
    localStorage.setItem(PWA_BANNER_DISMISSED_KEY, 'true');
    setDismissed(true);
  };

  if (!canShow || dismissed) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-lg">
      <div className="flex items-center gap-3 px-4 py-3 rounded-xl bg-[#103254] text-white shadow-2xl shadow-[#103254]/40">
        <div className="w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center shrink-0">
          <Download className="w-4 h-4 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold leading-tight">
            Instala Bookoll en tu móvil
          </p>
          <p className="text-[11px] text-white/70 mt-0.5 leading-tight">
            {isIOS
              ? 'Pulsa compartir en Safari → "Añadir a pantalla de inicio"'
              : 'Accede más rápido desde tu pantalla de inicio'}
          </p>
        </div>
        {!isIOS && (
          <button
            onClick={install}
            className="shrink-0 bg-white text-[#103254] text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-blue-50 transition-colors"
          >
            Instalar
          </button>
        )}
        <button
          onClick={dismiss}
          className="shrink-0 text-white/60 hover:text-white transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
